import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import useMediaQuery from '@/hooks/useMatchMedia';
import Sticker from '@/uikit/Sticker/Sticker';

import styles from './styles.module.scss';

interface NavigationLinkProps {
  route: string,
  icon: React.ReactNode,
  isMenuOpened: boolean,
  onClick: () => void,
  stickerText?: string | number,
  lngKey: string,
}

const NavigationLink: FC<NavigationLinkProps> = ({
  route,
  icon,
  isMenuOpened,
  onClick,
  stickerText,
  lngKey,
}) => {
  const { t } = useTranslation();

  const setLinkStyle = (
    { isActive }: { isActive: boolean },
  ) => (isActive ? `${styles.activeLink} ${styles.link}` : styles.link);
  const isMatch1440PX = useMediaQuery('(max-width: 1440px)');

  return (
    <li onClick={onClick}>
      <NavLink
        to={route}
        className={setLinkStyle}
        end
      >
        {icon}
        {(!isMatch1440PX || isMenuOpened) && (
          <p>
            {t(lngKey)}
            {stickerText ? <Sticker>{stickerText}</Sticker> : null}
          </p>
        )}
      </NavLink>
    </li>
  );
};

export default NavigationLink;
